import { Button, Input } from 'antd';
import React from 'react';
import styled from 'styled-components';
import colors from '../../constants/colors';
import scale from '../../constants/scale';
import Text from '../Text';
import ErrorMessage from '../Styled/ErrorMessage';

type EmailCard = {
    values: any;
    setFieldValue: any;
    errors: any;
    changeStep: (direction: 'prev' | 'next') => void;
};

const Card = styled.div`
    background-color: ${colors.white}FF;
    display: grid;
    grid-template-columns: auto;
    grid-template-rows: repeat(3, min-content);
    grid-gap: ${scale.lg};
    padding: ${scale.xl};
    border-radius: 2px;
`;

const PositionedButton = styled(Button)`
    justify-self: start;
    text-transform: uppercase;
`;

const EmailCard: React.FC<EmailCard> = ({ values, setFieldValue, errors, changeStep }) => {
    return (
        <Card>
            <Text size="22" center>
                Register
            </Text>

            <Input
                style={{ width: 245 }}
                value={values.contactEmailAddress}
                placeholder="EMAIL ADDRESS"
                onChange={(e) => {
                    setFieldValue('contactEmailAddress', e.target.value);
                }}
            />

            {errors.contactEmailAddress && <ErrorMessage>{errors.contactEmailAddress}</ErrorMessage>}

            <PositionedButton
                onClick={() => changeStep('next')}
                disabled={Object.keys(errors).length !== 0}
                style={{ color: colors.white, backgroundColor: colors.red }}
            >
                Next
            </PositionedButton>
        </Card>
    );
};

export default EmailCard;
